import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Cookies from 'universal-cookie';

import Config from '../../../../../../../../../../../../controllers/config';

import Word from '../../../../../../../../../../../../assets/word.png';
import Excel from '../../../../../../../../../../../../assets/excel.png';
import PowerPoint from '../../../../../../../../../../../../assets/power-point.png';

//css
import CardFileCss from './CardFile-css';
const useStylesCard = CardFileCss();

export default function CardFile(props) {
    const classes = useStylesCard();
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    const url = `${Config.URL_BACKEND}/compliance/${token}/${props.state.id}`;

    function handlerArquivo(e) {
        if (e.target.files.length > 0) {
            var campo = e.target.value;
            var filename = e.target.files[0].name;
            props.setState({
                arquivo: campo,
                arquivoName: filename
            });
    
            valTamanhoArquivo();
            valExtensaoArquivo();
        }
    }

    function handlerDeleteArquivo() {
        props.setState({
            arquivo: '',
            arquivoName: '',
            arquivoIndicacao: null,
            arquivoIndicacaoNome: null,
            arquivoIndicacaoDisplay: true,
        });
        document.querySelector('input[type="file"]').value = "";
    }

    function handlerEditArquivo() {
        props.setState({editFileMode: true});
    }

    function valTamanhoArquivo() {
        const lb_tamanho = document.querySelector('#tamanho');
        const file = document.querySelector('input[type="file"]').files[0];
        const tamanho = formatBytes(file.size);
        if (tamanho.size > 7.00) {
            lb_tamanho.classList.add("vermelho");
            handlerDeleteArquivo();
        } else {
            lb_tamanho.classList.remove("vermelho");
        }
    }

    function valExtensaoArquivo() {
        const lb_extensao = document.querySelector('#extensao');
        const file = document.querySelector('input[type="file"]').files[0];
        if (file != null) {
            const length = file.name.split(".").length;
            const extension = file.name.split(".")[length-1];
            if (
                extension.toLowerCase() === 'pdf' ||
                extension.toLowerCase() === 'ppt' ||
                extension.toLowerCase() === 'pptx' ||
                extension.toLowerCase() === 'doc' ||
                extension.toLowerCase() === 'docx' ||
                extension.toLowerCase() === 'xls' ||
                extension.toLowerCase() === 'xlsx'
            ) {
                lb_extensao.classList.remove("vermelho");
            } else {
                lb_extensao.classList.add("vermelho");
                handlerDeleteArquivo();
            }
        }
    }

    function formatBytes(bytes){
        var kb = 1024;
        var ndx = Math.floor( Math.log(bytes) / Math.log(kb) );
        var fileSizeTypes = ["bytes", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];
        
        return {
            size: +(bytes / kb / kb).toFixed(2),
            type: fileSizeTypes[ndx]
        };
    }

    return (
        <Card className={classes.card}>
            <CardContent>

                {!props.state.editFileMode &&
                    <div>
                        {(
                            (props.state.arquivoIndicacao !== '' && props.state.arquivoIndicacaoDisplay)
                        ) &&
                            <div>
                                {props.state.arquivoExtensao == "pdf" &&
                                    <iframe 
                                        src={url}
                                    />
                                }
                                {(
                                    props.state.arquivoExtensao == "doc" || 
                                    props.state.arquivoExtensao == "docx"
                                ) &&
                                    <img src={Word} alt={"Word"} width={"25%"} height={"25%"}/>
                                }
                                {(
                                    props.state.arquivoExtensao == "xls" || 
                                    props.state.arquivoExtensao == "xlsx"
                                ) &&
                                    <img src={Excel} alt={"Excel"} width={"25%"} height={"25%"}/>
                                }
                                {(
                                    props.state.arquivoExtensao == "ppt" || 
                                    props.state.arquivoExtensao == "pptx"
                                ) &&
                                    <img src={PowerPoint} alt={"Power Point"} width={"25%"} height={"25%"}/>
                                }
                                <div className={classes.acoes}>
                                    <IconButton 
                                        aria-label="edit" 
                                        onClick={handlerEditArquivo}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                    <br/>
                                    <a href={url} target={"__blank"} >
                                        <IconButton 
                                            aria-label="edit"
                                        >
                                            <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                    </a>
                                </div>
                            </div>
                        }
                    </div>
                }

                {props.state.editFileMode &&
                    <div>
                        <Typography className={classes.cardFileText} color="textSecondary" gutterBottom>
                            Selecione um arquivo ou informe uma URL
                        </Typography>
                        <div className={classes.buttonFile}>
                            <input
                                accept=".pdf, .ppt, .pptx, .xls, .xlsx, .doc, .docx"
                                className={classes.input}
                                id="raised-button-file"
                                multiple
                                type="file"                                        
                                onChange={handlerArquivo}
                            />
                            {
                            document.querySelector('input[type="file"]') &&
                            document.querySelector('input[type="file"]').files.length > 0 && 
                                <label>{props.state.arquivoName}
                                    <IconButton 
                                        aria-label="delete" 
                                        className={classes.margin}
                                        onClick={handlerDeleteArquivo}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </label>
                            }
                            <label htmlFor="raised-button-file" align="center">
                                <Button 
                                    raised="true" 
                                    component="span" 
                                    variant="contained" 
                                    color="primary" 
                                    className={classes.button} 
                                >
                                    Upload do Arquivo
                                </Button>
                            </label>
                            <div 
                                id={"extensao"}
                                className={classes.cardFileText}
                            >
                                Arquivos .pdf, .ppt, .pptx, .xls, .xlsx, .doc, .docx são aceitos!
                            </div>
                            <div 
                                id={"tamanho"}
                                className={classes.cardFileText}
                            >
                                Tamanho máximo de arquivo 7mb.
                            </div>
                        </div>
                    </div>
                }

            </CardContent>
        </Card>
    );
}